import React, { useEffect } from "react";
import { useDropzone } from "react-dropzone";
import "./DragAndDrop.scss";
import { successButtonSVG, trashIconSVG } from "../../shared/images/icons";
import { fileNameMaker, setIconDragAndDrop } from "../../utils";
import { useSelector } from "react-redux";

export const DragAndDrop = ({
  text,
  type,
  fileadd,
  fileremove,
  sizeError,
  typeError,
  lang,
}) => {
  const { selectedPassportType } = useSelector((state) => state.mainState);
  const { acceptedFiles, getInputProps, getRootProps } = useDropzone();

  const removeAll = () => {
    if (acceptedFiles.length > 0) {
      acceptedFiles.pop();
    }
  };
  useEffect(() => {
    if (selectedPassportType === 1) {
      removeAll();
    } else if (selectedPassportType === 2) {
      removeAll();
    }
    // eslint-disable-next-line
  }, [selectedPassportType]);

  const handleFileAdd = async (file, type) => {
    fileadd(file, type);
  };
  let files;
  const removeFile = (file) => () => {
    if (acceptedFiles.length > 1) {
      fileremove(file);
      acceptedFiles.length = 0;
      files = null;
    } else {
      fileremove(file);
      acceptedFiles.splice(acceptedFiles.indexOf(file), 1);
    }
  };

  if (acceptedFiles[0]) {
    const file = acceptedFiles[0];
    files = (
      <span className="loaded-file" key={file.path}>
        <span>
          {successButtonSVG}
          <span className="ml-3">
            {fileNameMaker(file.type, type, file.size)}
          </span>
        </span>

        <span className="trash-icon" onClick={removeFile(file)}>
          {trashIconSVG}
        </span>
      </span>
    );
  }
  if (acceptedFiles.length > 0 && acceptedFiles[0].size >= 6000000) {
    sizeError(true);
    files = [];
    acceptedFiles.pop();
  }
  if (acceptedFiles.length > 0 && acceptedFiles[0].size <= 6000000) {
    switch (acceptedFiles[0].type) {
      case "image/jpeg":
      case "image/png":
      case "application/pdf":
        handleFileAdd(acceptedFiles[0], type);
        return (
          <div className="big-sized">
            <div className="loaded-passport-side">
              <div className="row">
                <div className="label-loaded">{files}</div>
              </div>
            </div>
          </div>
        );
      default:
        typeError(true);
        files = [];
        acceptedFiles.pop();
        return (
          <div {...getRootProps({ className: "dragdropzone" })}>
            <div className="drop-passport-icon">{setIconDragAndDrop(type)}</div>
            <div className="drop-description">{text}</div>
            <div className="select-file-btn">
              <div className="s-label-btn">
                {lang === "tj" ? "Файлро интихоб кунед" : "Выберите файлы"}
              </div>
            </div>
            <input
              {...getInputProps()}
              accept=".jpg,.png,.pdf"
              multiple={false}
            />
          </div>
        );
    }
  }

  return (
    <div {...getRootProps({ className: "dragdropzone" })}>
      <div className="drop-passport-icon">{setIconDragAndDrop(type)}</div>
      <div className="drop-description">{text}</div>
      <div className="select-file-btn">
        <div className="s-label-btn">
          {lang === "tj" ? "Файлро интихоб кунед" : "Выберите файлы"}
        </div>
      </div>
      <input {...getInputProps()} accept=".jpg,.png,.pdf" multiple={false} />
    </div>
  );
};
